import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Wrapper = styled.article`
  border-bottom: 5px solid var(--primary-500);
  background: var(--background-secondary-color);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-2);
  margin: 2rem 1rem;

  .logo {
    width: 80px; /* Set the image width */
    height: auto; /* Maintain aspect ratio */
  }
`;

const Header = styled.header`
  padding: 1rem 0rem;
  border-bottom: 1px solid var(--grey-100);
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
`;

const MainIcon = styled.div`
  /* width: 60px;
  height: 60px; */
  display: grid;
  place-items: center;
  background: var(--primary-500);
  border-radius: var(--border-radius);
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--white);
  margin-right: 2rem;
  img {
    width: 50px; /* Set the image width */
    height: auto; /* Maintain aspect ratio */
  }
`;

const Info = styled.div`
  h5 {
    margin-bottom: 0.5rem;
    margin-right: 1rem;
  }
  p {
    margin: 0;
    margin-right: 1rem;
    text-transform: capitalize;
    letter-spacing: var(--letter-spacing);
    color: var(--text-secondary-color);
  }
`;

const Content = styled.div`
  padding: 1rem 1rem;
`;

const Actions = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content:end;
`;



const EditButton = styled(Link)`
  height: 30px;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  text-decoration: none;
  color: var(--white); 
  background-color: var(--primary-500); 
  padding: 0.25rem 0.5rem;
  border-radius: var(--border-radius);
  &:hover {
    background-color: var(--primary-700);
  }
`;

const BusinessRow = ({ name, logo, direction }) => {
  return (
    <Wrapper>
      <Header>
        <MainIcon>
          <img src={logo} alt={name} className='logo'  />
        </MainIcon>
        <Info>
          <h5>{name}</h5>
          <p>{direction}</p>
        </Info>
      </Header>
      <Content>
        <Actions>
          <EditButton to={`/business/${name}`}>עריכה</EditButton>
          <EditButton style={{background : 'red'}} to={`/business/${name}`}>מחיקה</EditButton>
        </Actions>
      </Content>
    </Wrapper>
  );
};

BusinessRow.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string,
  direction: PropTypes.string,
  handleChange: PropTypes.func,
  value: PropTypes.string,
};

export default BusinessRow;
